import { Injectable } from '@angular/core';
import { AbstractOfflineStorageAsyncTimestampService } from '../abstract/abstract-offline-storage-async-timestamp.service';
import { ImmoIPTourOrderChangesObject } from './immo-ip-tour-order-changes-object';
import { ExpiredImmoIPTourOrderChangesRemover } from './expired-immo-ip-tour-order-changes-remover';
import { NgForage } from 'ngforage';
import { NgForageTimestampService } from '../../ng-forage/ng-forage-timestamp.service';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';

@Injectable({
  providedIn: 'root',
})
export class ImmoIPTourOrderChangesService extends AbstractOfflineStorageAsyncTimestampService<
  number,
  ImmoIPTourOrderChangesObject,
  ExpiredImmoIPTourOrderChangesRemover
> {
  constructor(
    protected ngForage: NgForage,
    protected ngForageTimestampService: NgForageTimestampService
  ) {
    super(
      'immo-ip-tour-order-change-',
      'immo-ip-tour-order-changes',
      ngForage,
      ngForageTimestampService
    );
  }

  // Override
  protected instantiateRemover(): ExpiredImmoIPTourOrderChangesRemover {
    return new ExpiredImmoIPTourOrderChangesRemover(
      this,
      this.ngForage,
      this.ngForageTimestampService
    );
  }

  // Override
  protected verifyToStoreObject(object: ImmoIPTourOrderChangesObject): void {
    if (object == null) {
      throw new Error('immoIPTourOrderChangesObject must not be null');
    }
    if (object.id == null) {
      throw new Error('immoIPTourOrderChangesObject.id must not be null');
    }
    if (!CollectionHelper.isPopulated(object.tourItemIdSequenceNumberPairs)) {
      throw new Error(
        'immoIPTourOrderChangesObject.tourItemIdSequenceNumberPairs must not be null or empty'
      );
    }
  }
  public cleanupOfflineObject(
    object: ImmoIPTourOrderChangesObject
  ): Promise<void> {
    //Method not implemented.
    return Promise.resolve();
  }
  public override convertToID(o: any): number {
    const toReturn = GeneralHelper.isNumeric(o) ? o : Number(o);
    if (!GeneralHelper.isNumeric(toReturn)) {
      throw new Error(`${o} could not be converted to number`);
    }
    return toReturn;
  }

  protected override stringifyID(id: number): string {
    return id.toString();
  }

  public async removeIfUuidMatch(tourId: number, uuid: string): Promise<void> {
    const object = await this.getObjectNoTimestampUpdate(tourId);
    if (object != null && object.uuid === uuid) {
      await this.removeObject(object);
    }
  }
}
